import { render, staticRenderFns } from "./growthRecord.vue?vue&type=template&id=2a952fd2"
import script from "./growthRecord.vue?vue&type=script&lang=js"
export * from "./growthRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports